module.exports = __webpack_public_path__ + "static/media/40-2.a1337db0.mp3";